import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { IAppState } from 'app/store';
import { UserService } from 'app/shared/services/user.service';
import { User } from 'app/shared/models/user';
import { KeyBase, Key, IEntity, ItemAdded, ItemChanged } from '@kpd/framework-ngx';
import { environment } from 'environments/environment';
import { UserManagementEntityFacade } from './usermanagement.facade';

@Injectable()
export class UserFacade extends UserManagementEntityFacade {
  constructor(private userService: UserService, store: Store<IAppState>) {
    super('users', store, userService, environment);
  }

  saveItem(user: User): Observable<User> {
    const subject = new Subject<User>();
    this.userService.save(user).subscribe(
      (updatedUser) => {
        if (user.isNew()) {
          this.store.dispatch(new ItemAdded('users', updatedUser));
        } else {
          this.store.dispatch(new ItemChanged('users', updatedUser));
        }

        subject.next(updatedUser);
        subject.complete();
      },
      (error) => {
        subject.error(error);
        subject.complete();
      },
    );
    return subject;
  }

  composeKeyByRouteParams(params: { id: string }): KeyBase {
    return Key.composeKeyByRouteParams(params);
  }

  toggleRole(userKey: Key<string>, applicationName: string, roleName: string, add: boolean): Subject<boolean> {
    const subject = new Subject<boolean>();

    this.userService.toggleRole(userKey, applicationName, roleName, add).subscribe(
      () => {
        subject.next(add);
        subject.complete();
      },
      (error) => {
        subject.error(error);
        subject.complete();
      },
    );

    return subject;
  }

  createNewEntity(): IEntity {
    return new User();
  }

  reloadUser(user: User): any {
    return this.userService.getById(user.key, true);
  }

  unlockUser(user: User): Observable<any> {
    return this.userService.unlockUser(user.key.id);
  }
}
